<template>
    <div class="load-error">
        {{ text }}
    </div>
</template>

<script>
    export default {
        name: 'LoadError',
        data() {
            return {
                text: ''
            }
        }
    }
</script>
